import { useCallback } from 'react'
import { useFeatureFlag } from '~/context/featureFlag'
import { type ProductSlug } from '~/schemas/browserUrl'

// Which products have the new contentful search page enabled
export const ENABLED_FEATURE_PRODUCTS: Set<ProductSlug> = new Set(['hotels', 'cars', 'experiences'])

export const PRODUCT_LEGACY_PATHS: Record<ProductSlug, string> = {
  flights: '/?tab=flights',
  hotels: '/?tab=hotels',
  cars: '/?tab=carhire',
  experiences: '/?tab=experiences',
}

export const getProductLegacyPath = (productSlug: ProductSlug) => {
  return PRODUCT_LEGACY_PATHS[productSlug] || PRODUCT_LEGACY_PATHS.hotels
}

/** temporary while new home page is under feature toggle */
export const useIsSearchPageEnabled = () => {
  const isHomePageEnabled = useFeatureFlag('homepage-contentful-rebuild')

  const getSlugFromQuery = useCallback((productSlug: string): ProductSlug => {
    switch (productSlug) {
      case 'flights':
        return 'flights'
      case 'hotels':
        return 'hotels'
      case 'carhire':
      case 'cars':
        return 'cars'
      case 'experiences':
        return 'experiences'
      default:
        return 'hotels'
    }
  }, [])

  const isProductEnabled = useCallback(
    (productSlug: ProductSlug | 'carhire'): boolean => {
      // temporary for old car hire url mapping
      const normalizedSlug = getSlugFromQuery(productSlug)

      return isHomePageEnabled && ENABLED_FEATURE_PRODUCTS.has(normalizedSlug)
    },
    [getSlugFromQuery, isHomePageEnabled]
  )

  return { isProductEnabled, getSlugFromQuery }
}
